import React from 'react';
import { Spinner } from '@/components/ui/spinner';

interface LoadingSpinnerProps {
  message?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  className = '',
}) => {
  return (
    <div
      data-test-id="loading-spinner"
      className={`flex items-center justify-center py-4 ${className}`}
    >
      <Spinner size="md" label={message} />
    </div>
  );
};
